import { useEffect, useState } from 'react';
import { StoreState } from '@root/types';
import { getTourbookById } from '@store/selectors';
import { connect, ConnectedProps, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import tourbooksActions from '@store/actions/tourbooks';
import actions from '@store/actions/tourbookPage';
import cn from 'classnames';
import contentWidth from '@styles/contentWidth.module.less';
import darkContentCss from '@styles/darkContentSection.module.less';
import LayoutContent from './LayoutContent';
import Layout from '../Layout';
import tourbookStyles from './Tourbook.module.less';
import TourbookSkeleton from './TourbookSkeleton';

const mapDispatch = {
  fetchTourbook: (id: string) => tourbooksActions.fetchTourbook(id),
  tourbookPageLoad: (id: string) => actions.tourbookPageLoad(id, true),
};

const connector = connect(null, mapDispatch);
type ReduxProps = ConnectedProps<typeof connector>;

export const Tourbook = ({ fetchTourbook, tourbookPageLoad }: ReduxProps) => {
  const { tourbookId } = useParams<{ tourbookId: string }>();
  const tourbook = useSelector((state: StoreState) => getTourbookById(state, tourbookId));
  const [loading, setLoading] = useState(true);
  const [isDuplicating, setIsDuplicating] = useState(false);
  const fetchCurrentTourbook = () => fetchTourbook(tourbookId);
  useEffect(() => {
    tourbookPageLoad(tourbookId).then(() => {
      setLoading(false);
    });
  }, [tourbookId, tourbookPageLoad]);

  return (
    <Layout
      activePage="tourbookShow"
      containerClassName={cn(
        tourbookStyles.tourbookShow,
        contentWidth.contentContainer,
        contentWidth.contentPadding,
        darkContentCss.darkContentSection,
        isDuplicating && tourbookStyles.blurFilter,
      )}
    >
      <>
        <TourbookSkeleton visible={loading} />
        {!loading && tourbook ? (
          <LayoutContent
            tourbook={tourbook}
            fetchTourbook={fetchCurrentTourbook}
            readOnly
            isDuplicating={isDuplicating}
            setIsDuplicating={setIsDuplicating}
          />
        ) : null}
      </>
    </Layout>
  );
};

export default connector(Tourbook);
